import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  message,
  Card,
  Avatar,
  List,
  Tag,
  Button,
  Badge,
  Dropdown,
  Space,
  Empty,
  Spin,
  Modal,
} from "antd";
import {
  BellOutlined,
  ReloadOutlined,
  DeleteOutlined,
  FilterOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminFooter from "./AdminFooter";
import "../assets/admin/css/adminnotification.css";

export const AdminNotification = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all"); // "all", "unread", "read"
  const apiURL = "https://jlmining.app/api/usersnotification";
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };

  useEffect(() => {
    changeFavicon(require("../assets/admin/images/f-icon.png"));
    document.title = "Notification Center - Admin Panel";

    const userStr = JSON.parse(localStorage.getItem("admin"));
    if (userStr == null) {
      navigate("/admin/login");
    }

    fetchNotifications();
  }, []);
  const deleteNotifications = () => {
    Modal.confirm({
      title: "Delete All Notifications",
      content: "Are you sure you want to delete all notifications?",
      okText: "Yes, Delete All",
      cancelText: "Cancel",
      okType: "danger",
      onOk() {
        // Execute delete operation
        let formdata = {};
        axios
          .post(apiURL + "/Deleteallnotifcation", formdata, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            fetchNotifications();
            message.success("Notifications deleted successfully");
          })
          .catch((err) => {
            setLoading(false);
            message.error("Failed to delete notifications");
          });
      },
      onCancel() {
        // Optional: You can add any cleanup logic here if needed
        console.log("Delete cancelled");
      },
    });
  };
  const fetchNotifications = () => {
    setLoading(true);
    let formdata = {};
    axios
      .post(apiURL + "/getallnotifcation", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.data;
        setNotifications(alldata);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error("Failed to load notifications");
      });
  };

  useEffect(() => {
    if (notifications) {
      const ws = new WebSocket("wss://jlmining.app");

      ws.onmessage = (event) => {
        try {
          const receivedMessage = JSON.parse(event.data);
          console.log(receivedMessage);

          if (receivedMessage.event === "AssignNewCourse") {
            fetchNotifications();
          }
        } catch (error) {
          console.error("Failed to parse WebSocket message:", error);
          console.error("Raw message:", event.data);
        }
      };

      ws.onopen = () => {
        console.log("WebSocket connection established");
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      return () => {
        ws.close();
        console.log("WebSocket connection closed");
      };
    }
  }, [notifications]);

  const markAsRead = (id) => {
    // Implement mark as read functionality
    let formdata = { id: id };
    axios
      .post(apiURL + "/updatenotifications", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        message.success("Marked as read");
        fetchNotifications();
      })
      .catch((err) => {
        setLoading(false);
        message.error("Failed to load notifications");
      });
  };

  const deleteNotification = (id) => {
    // Implement delete functionality
    let formdata = { id: id };
    axios
      .post(apiURL + "/deleteNotifications", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        message.success("Notification deleted");
        fetchNotifications();
      })
      .catch((err) => {
        setLoading(false);
        message.error("Failed to load notifications");
      });
  };

  const getInitials = (firstName, middleName, lastName) => {
    return `${firstName ? firstName[0] : ""}${middleName ? middleName[0] : ""}${lastName ? lastName[0] : ""
      }`;
  };

  const getTimeAgo = (dateString) => {
    const [day, month, year] = dateString.split("/").map(Number);
    const date = new Date(year, month - 1, day); // month is 0-indexed
    const now = new Date();

    const diffInSeconds = Math.floor((now - date) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInSeconds / 3600);
    const diffInDays = Math.floor(diffInSeconds / 86400);
    const diffInMonths =
      now.getMonth() -
      date.getMonth() +
      12 * (now.getFullYear() - date.getFullYear());
    const diffInYears = now.getFullYear() - date.getFullYear();

    if (diffInSeconds < 60) return "Just now";
    if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;
    if (diffInHours < 24) return `${diffInHours} hours ago`;
    if (diffInDays < 30) return `${diffInDays} days ago`;
    if (diffInMonths < 12) return `${diffInMonths} months ago`;
    return `${diffInYears} years ago`;
  };

  const filteredNotifications = notifications.filter((notification) => {
    const markread = notification.markread?.toLowerCase(); // normalize

    if (filter === "all") return true;
    if (filter === "unread") return markread === "no";
    if (filter === "read") return markread === "yes";
    return true;
  });

  const notificationActions = (item) => (
    <Space>
      <Button
        type="text"
        icon={<CheckOutlined />}
        size="small"
        onClick={() => markAsRead(item.id)}
      >
        Mark as read
      </Button>
      <Button
        type="text"
        icon={<DeleteOutlined />}
        size="small"
        danger
        onClick={() => deleteNotification(item.id)}
      >
        Delete
      </Button>
    </Space>
  );
  const [visibleCount, setVisibleCount] = useState(10); // Start by showing 5 notifications

  const loadMoreNotifications = () => {
    // Increase the visible count by 5 (or any number you prefer)
    setVisibleCount((prevCount) => prevCount + 5);
  };
  const getTimeAgoTime = (dateString) => {
    const date = new Date(dateString); // works with ISO strings
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600)
      return `${Math.floor(diffInSeconds / 60)} minutes ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    if (diffInSeconds < 2592000)
      return `${Math.floor(diffInSeconds / 86400)} days ago`;
    if (diffInSeconds < 31104000)
      return `${Math.floor(diffInSeconds / 2592000)} months ago`;
    return `${Math.floor(diffInSeconds / 31104000)} years ago`;
  };

  return (
    <>
      <div>
        <AdminHeader />
        <div className="main-right-body">
          <div className="page-header">
            <div className="page-title">
              <BellOutlined className="header-icon" />
              <h1>Notification Center</h1>
              <div className="notification-stats">
                <Badge
                  count={notifications.length}
                  showZero
                  className="total-badge"
                  title="Total notifications"
                />
                <div className="count-breakdown">
                  <span className="unread-count">
                    <Badge status="processing" />
                    {
                      filteredNotifications.filter(
                        (n) => n.markread && n.markread.toLowerCase() === "no"
                      ).length
                    }{" "}
                    unread
                  </span>
                  <span className="read-count">
                    <Badge status="default" />
                    {
                      filteredNotifications.filter(
                        (n) => n.markread && n.markread.toLowerCase() === "yes"
                      ).length
                    }{" "}
                    read
                  </span>
                </div>
              </div>
            </div>
            <div className="header-actions">
              <Button
                icon={<DeleteOutlined />}
                onClick={deleteNotifications}
                loading={loading}
              >
                Delete All Notification
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={fetchNotifications}
                loading={loading}
              >
                Refresh
              </Button>
              <Dropdown
                menu={{
                  items: [
                    {
                      key: "1",
                      label: "All notifications",
                      onClick: () => setFilter("all"),
                    },
                    {
                      key: "2",
                      label: "Unread only",
                      onClick: () => setFilter("unread"),
                    },
                    {
                      key: "3",
                      label: "Read only",
                      onClick: () => setFilter("read"),
                    },
                  ],
                }}
                placement="bottomRight"
              >
                <Button icon={<FilterOutlined />}>Filter</Button>
              </Dropdown>
            </div>
          </div>

          <Card className="notification-card">
            {loading ? (
              <div className="loading-container">
                <Spin size="large" />
                <p>Loading notifications...</p>
              </div>
            ) : filteredNotifications.length > 0 ? (
              <>
                <List
                  itemLayout="horizontal"
                  dataSource={filteredNotifications.slice(0, visibleCount)}
                  renderItem={(item, index) => (
                    <List.Item
                      className={
                        item.markread === "Yes"
                          ? "notification-item read"
                          : "notification-item unread"
                      }
                      actions={[notificationActions(item)]}
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar className="notification-avatar">
                            {getInitials(
                              item.first_name,
                              item.middle_name,
                              item.last_name
                            )}
                          </Avatar>
                        }
                        title={
                          <div className="notification-title">
                            <span className="user-name">
                              {item.first_name} {item.middle_name}{" "}
                              {item.last_name}
                            </span>
                            <Tag
                              color={item.priority === "high" ? "red" : "blue"}
                              className="notification-tag"
                            >
                              {item.type || "Info"}
                            </Tag>
                            {item.markread === "No" && (
                              <Badge dot className="unread-badge" />
                            )}
                          </div>
                        }
                        description={
                          <div className="notification-content">
                            <p>{item.message}</p>
                            <div className="notification-footer">
                              <span className="notification-time">
                                {item.nd}
                              </span>

                              <span className="notification-time text-dark">
                                {getTimeAgoTime(item.created_at)}
                              </span>
                            </div>
                          </div>
                        }
                      />
                    </List.Item>
                  )}
                />
                {visibleCount < filteredNotifications.length && (
                  <div className="view-more-container">
                    <Button
                      type="primary"
                      onClick={loadMoreNotifications}
                      className="view-more-btn"
                    >
                      View More
                    </Button>
                  </div>
                )}
              </>
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  filter !== "all"
                    ? `No ${filter} notifications`
                    : "No notifications yet"
                }
              />
            )}
          </Card>
        </div>
        <AdminFooter />
      </div>
    </>
  );
};
